import QuickCraftFail from "./QuickCraftFail";
import QuickCraftStart from "./QuickCraftStart";
import QuickCraftSuccess from "./QuickCraftSuccess";

const QuickCraftSteps = ({ name, step, closeWindow, handleCraftButton, data, choosedOptions, setChoosedOptions }) => {
  const selectHandler = (event, itemMain) => {
    const { name, value } = event.target;

    setChoosedOptions((prevOptions) =>
      prevOptions.map((option) =>
        option.label === itemMain.label ? { ...option, [name]: value } : option
      )
    );
  };

  return (
    <>
      {step === "start" && (
        <QuickCraftStart
          name={name}
          data={data}
          choosedOptions={choosedOptions}
          selectHandler={selectHandler}
          closeWindow={closeWindow}
          handleCraftButton={handleCraftButton}
        />
      )}

      {step === "success" && <QuickCraftSuccess closeWindow={closeWindow} />}

      {step === "fail" && <QuickCraftFail closeWindow={closeWindow} />}
    </>
  );
};

export default QuickCraftSteps;
